import { useEffect, useRef, useState } from 'react';

// Native date input that commits on BLUR (or Enter), never on change — same
// house pattern as Operations.jsx DateRangeCell. Shared by the Estimating and
// Requests equipment date cells. A date input fires `change`
// on every completed segment, so saving on change PUT a half-typed year (0002,
// 0020, 0202 while typing 2026) and derived a ~730,000-day equipment span.
// Keystrokes move local state only; the prop sync is skipped while focused.
// `onCommit` may return a promise: once it settles the box re-reads the saved
// value, so a refused save (server 400, shown in the page error box) reverts.
export default function BlurDateInput({ value, onCommit, ...rest }) {
  const iso = value ? String(value).slice(0, 10) : '';
  const [v, setV] = useState(iso);
  const ref = useRef(null);
  const latest = useRef(iso);
  latest.current = iso;
  useEffect(() => { if (document.activeElement !== ref.current) setV(iso); }, [iso]);
  const commit = async (val) => {
    if (val === latest.current) return;
    await onCommit(val || null);
    if (document.activeElement !== ref.current) setV(latest.current);
  };
  return (
    <input type="date" ref={ref} value={v} {...rest}
      onChange={e => setV(e.target.value)}
      onBlur={e => {
        // A half-cleared date reads as '' with badInput set: revert, don't save NULL.
        if (e.target.validity.badInput) { setV(latest.current); return; }
        commit(e.target.value);
      }}
      onKeyDown={e => { if (e.key === 'Enter') e.currentTarget.blur(); }} />
  );
}
